import * as logClient from "@classdojo/log-client";
import { type Env } from "@classdojo/log-client/lib/client/types";

// Must be the FIRST import in root.tsx so logClient.init() fires before errorHandling wires up window.onerror.
const envMap: Record<string, Env> = { production: "prod", development: "dev", test: "testing" };
const env: Env = envMap[Config.nodeEnv] ?? "dev";

if (typeof window !== "undefined") {
  logClient.init({
    env,
    site: "toolkit",
    buildNumber: window.buildNumber,
    appVersion: window.appVersion,
  });
}
